import { useEffect, useState } from 'react';

import { build_cdn_files_url } from '../../../../services/projectservice.js'




export default function CDNImageDemo({}) {

    const [ imgUrl, setImgUrl ] = useState('');
    
    // const example_photo_url = 'https://projectservice.huntercbuxton.com/cdn/ksb/files/asdasdasd.png'

    const fetch_cdn_url = () => {
        const url = build_cdn_files_url('asdasdasd.png')
        console.log('url built : ', url)
        setImgUrl(url);
    }

    useEffect(() => {
        fetch_cdn_url()
    }, [])

    return (<>
    
        <h2>CDN Image File Demo</h2>
        <img src={imgUrl} alt="cdn demo image"></img>
           
    </>) 

}

